<template>
  <div class="agencyList">
    <div class="top">
      <search-input @search="onSearch" ref="search"></search-input>
      <!-- <div class="icon" @click="mouseSearch"><van-icon name="location" /></div> -->
    </div>
    <div class="list">
      <agency-item
        @click.native="togglePage('agencyDetail', item.orgId)"
        v-for="item in orgList"
        :key="item.orgId"
        :item="item"
      ></agency-item>
    </div>
  </div>
</template>

<script>
import { getOrganList } from "@/api/agency.js";
import { areaCode } from "@/common/constants.js";
import list from "@/common/staticOrgData.json";
export default {
  name: "agencyList",
  data() {
    return {
      form: {
        areaCode,
        orgTypes: this.$route.query.orgTypes,
        orgName: ""
      },
      orgList: []
    };
  },
  methods: {
    togglePage(name, orgId) {
      this.$router.push({ name, query: { orgId } });
    },
    async getAgencyList() {
      const { data } = await getOrganList(this.form);
      this.orgList = data.list;
    },
    mouseSearch() {
      this.form.orgName = this.$refs.search.value;
      this.$refs.search.value = "";
      this.getAgencyList();
    },
    onSearch(val) {
      this.form.orgName = val;
      this.getAgencyList();
    }
  },
  mounted() {
    // console.log(list);
    switch (this.$route.query.orgTypes) {
      case "1010":
        this.orgList.push(list["list"][4]);
        return;
      case "2025":
        this.orgList.push(list["list"][1]);
        this.orgList.push(list["list"][2]);
        return;
      case "2026":
        this.orgList.push(list["list"][3]);
        return;
      case "2027":
        this.orgList.push(list["list"][0]);
        this.orgList.push(list["list"][5]);
        return;
    }

    this.getAgencyList();
  }
};
</script>

<style lang="scss" scoped>
.agencyList {
  .top {
    display: flex;
    margin-bottom: 20px;
    .search-input {
      width: 330px;
      ::v-deep {
        .van-search {
          .van-search__content {
            background-color: #fff8e9 !important;

            .van-field {
              background-color: #fff8e9 !important;
              border-radius: 100px !important;
              .van-field__control {
                &::placeholder {
                  opacity: 1;
                  font-size: 12px;
                  font-family: PingFang SC, PingFang SC-Regular;
                  font-weight: 400;
                  text-align: left;
                  color: #707070;
                }
              }
            }
          }
        }
      }
    }
    .icon {
      padding-top: 10px;
      .van-icon {
        color: #FFB83C;
        font-size: 30px;
      }
    }
  }

  .list {
    border-top: 8px solid #fff8e9;
    ::v-deep {
      .agencyItem {
        .contain {
          border-bottom: 4px solid #fff8e9 !important;
          .van-icon {
            color: #FFB83C;
          }
        }
      }
    }
  }
}
</style>
